
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import { ILeiConsideracao } from '@/models/Entidades/ILeiConsideracao';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import ServicoLeiConsideracao from '@/servicos/ServicoLeiConsideracao';
import { IResposta } from '@/core/models/IResposta';
import EditorHtml from '@/core/components/UI/EditorHtml.vue';
import Card from '@/core/components/UI/Card.vue';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';

export default defineComponent({
  name: 'LeiConsideracaoCadastro',
  components: {
    ComunicacaoApi,
    Card,
    EditorHtml,
  },
  setup() {
    const {
      appBase, apresentarComunicacaoApi, apresentarRespostaRedirecionamento, obterCodigoRota,
    } = useAppBase();
    const servicoLeiConsideracao = new ServicoLeiConsideracao();

    const state = reactive({
      leiConsideracao: {} as ILeiConsideracao,
    });

    async function obterleiConsideracao(codigo:number) {
      appBase.carregando = true;
      state.leiConsideracao = await servicoLeiConsideracao.obter(codigo);
      appBase.carregando = false;
    }

    function limparDados() {
      state.leiConsideracao = {} as ILeiConsideracao;
      state.leiConsideracao.codigo = 0;
      state.leiConsideracao.status = true;
    }

    onBeforeMount(async () => {
      limparDados();
      const codigoleiConsideracao = obterCodigoRota();
      if (codigoleiConsideracao > 0) {
        await obterleiConsideracao(codigoleiConsideracao);
      }
    });

    async function salvar() {
      appBase.resposta = {} as IResposta;
      apresentarComunicacaoApi('Aguarde por favor... Estamos salvando as informações da lei e consideração.');
      if (state.leiConsideracao.codigo === 0) {
        appBase.resposta = await servicoLeiConsideracao.incluir(state.leiConsideracao);
      } else {
        appBase.resposta = await servicoLeiConsideracao.atualizar(state.leiConsideracao);
      }

      apresentarRespostaRedirecionamento('LeisConsideracoes');
    }

    return {
      appBase,
      state,
      salvar,
    };
  },
});
